import React, { useLayoutEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./screens/Home/Home";
import Medicine from "./screens/Medicine/Medicine";
import ProductDiscription from "./screens/ProductDiscription/ProductDiscription";
import PersonalCare from "./screens/PersonalCare/PersonalCare";
import CheckOut from "./components/CheckOut/CheckOut";
import BabyCare from './screens/BabyCare/BabyCare';
import AsaanOrder from './screens/AsaanOrder/AsaanOrder';
import DawaiPlus from './screens/DawaiPlus/DawaiPlus';
import Healthcare from './screens/Healthcare/Healthcare';
import Lifestyle from './screens/Lifestyle/Lifestyle';
import Offers from './screens/Offers/Offers';
import Organic from './screens/Organic/Organic';
import TrackOrder from './screens/TrackOrder/TrackOrder';
import ScrollToTop from "react-scroll-to-top";
import SignIn from "./screens/SignIn/SignIn";
import SignUp from "./screens/SignUp/SignUp";
import ContactSoon from "./screens/ContactSoon/ContactSoon";
import ComingSoon from "./screens/ComingSoon/ComingSoon";
import Checkout from "./components/CheckOut/CheckOut";
import Consultant from "./screens/Consultant/Consultant"
import HomeService from "./screens/HomeService/HomeService";
import LabTest from "./screens/LabTest/LabTest";

const App = () => {

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  return (
    <>

      <Router>
        <Wrapper>


          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/medicine" element={<Medicine />} />
            <Route path="/product-discription/:index" element={<ProductDiscription />} />
            <Route path="/personal-care" element={<PersonalCare />} />
            <Route path="/check-out" element={<CheckOut />} />
            <Route path="/BabyCare" element={<BabyCare />} />
            <Route path="/AsaanOrder" element={<AsaanOrder />} />
            <Route path="/DawaiPlus" element={<DawaiPlus />} />
            <Route path="/Offers" element={<Offers />} />
            <Route path="/PersonalCare" element={<PersonalCare />} />
            <Route path="/Organic" element={<Organic />} />
            <Route path="/TrackOrder" element={<TrackOrder />} />
            <Route path="/Healthcare" element={<Healthcare />} />
            <Route path="/Lifestyle" element={<Lifestyle />} />
            <Route path="/SignIn" element={<SignIn />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/ContactSoon" element={<ContactSoon />} />
            <Route path="/ComingSoon" element={<ComingSoon />} />
            <Route path="/Checkout" element={<Checkout />} />
            <Route path="/Consultant" element={<Consultant />} />
            <Route path="/HomeService" element={<HomeService />} />
            <Route path="/LabTest" element={<LabTest />} />
            
          </Routes>
        </Wrapper>

      </Router>
      <ScrollToTop smooth color="#ffffff" style={{ background: "#003b82", height: 50, width: 50 }} />
    </>
  );
};

export default App;
